module.exports = __webpack_public_path__ + "static/media/au-nsw.837c7246.svg";